export const liveInfoEventHandler = "liveInfoCall"

export const callExternalApi = (eventType, jsonParam) => {
  if (window.externalApi !== undefined && window.externalApi.emit !== undefined) {
    window.externalApi.emit(eventType, jsonParam)
  }
}
